{
  "customer-form": {
    "field": {
      "available_points": "Dostupné body",
      "birthday": "Narozeniny",
      "black_listed": "Černá listina",
      "black_listed_hint": "Zákazníci na černé listině si již nemohou rezervovat schůzky online.",
      "communication_way": "Způsob kontaktu",
      "email": "Email",
      "phone_nr": "Telefonní číslo",
      "name": "Název",
      "new_point_balance": "Nové skóre",
      "note": "Poznámka",
      "notification_subscribed": "Reklamní oznámení",
      "surname": "Příjmení",
      "update_point_balance": "Změna o (+/-) bodů"
    },
    "text": {
      "off": "OFF",
      "on": "ON"
    }
  }
}
